// import CookiesBanner from './cookies-banner';

function sayHello() {
  if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
    const args = ['\n %c Made with ❤️ by Dizzain %c https://www.dizzain.com/ %c %c 🔥 \n\n', 'border: 1px solid #000;color: #000; background: #fff001; padding:5px 0;', 'color: #fff; background: #1c1c1c; padding:5px 0;border: 1px solid #000;', 'background: #fff; padding:5px 0;', 'color: #b0976d; background: #fff; padding:5px 0;'];
    window.console.log.apply(console, args);
  } else if (window.console) {
    window.console.log('Made with love ❤️ Dizzain.com - https://www.dizzain.com/  ❤️');
  }
}

// window.addEventListener('load', (event) => {
//   window.setTimeout(() => {
//     sayHello();
//     new CookiesBanner(function() {
//       console.log('Cookies true');
//     }, true);
//   }, 1500);
// });

document.addEventListener( 'DOMContentLoaded', (event) => {
  document.body.classList.add('page-loaded');
});
